import React, { useState } from 'react';

import {
  Box,
  Typography,
  Button,
  TextField,
  Link,
  CircularProgress,
} from '@mui/material';
import SubmitButton from '../Buttons/SubmitButton';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { forgotPassword, resetPassword } from '../../store/slices/authSlice';

const ForgetPassword = ({ onBack }) => {

  const dispatch = useDispatch();

  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {

    e.preventDefault();
    setLoading(true);

    try {

      if (step === 1) {

        await dispatch(
          forgotPassword({
            type: 'email',
            value: email,
          })
        );

        toast.success('OTP sent to your email');
        setStep(2);

      } else {

        await dispatch(
          resetPassword({
            type: 'email',
            value: email,
            otp,
            password,
            password_confirmation: confirmPassword,
          })
        );

        toast.success('Password reset successfully');
        onBack();

      }

    } catch (error) {

      toast.error(
        error?.message ||
        'Something went wrong'
      );

    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        p: 4,
        borderRadius: 4,
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
        width: '100%',
        maxWidth: 400,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 3,
      }}
    >

      {/* LOGO */}
      <Box
        component="img"
        src="/images/revive-portal-logo.png"
        alt="Company Logo"
        sx={{ width: 140 }}
      />

      <Typography variant="h5" fontWeight={700}>
        {step === 1 ? 'Forgot Password' : 'Reset Password'}
      </Typography>

      <Typography variant="body2" color="text.secondary">
        {step === 1
          ? 'Enter your email to receive OTP'
          : 'Enter OTP and new password'}
      </Typography>

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >

        <TextField
          fullWidth
          label="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        {step === 2 && (
          <>
            <TextField
              label="OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />

            <TextField
              label="New Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <TextField
              label="Confirm Password"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </>
        )}

        <SubmitButton disabled={loading}>
          {loading ? (
            <>
              <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} />
              {step === 1 ? 'Sending OTP...' : 'Resetting...'}
            </>
          ) : step === 1 ? (
            'Send OTP'
          ) : (
            'Reset Password'
          )}
        </SubmitButton>

      </Box>

      <Link
        component="button"
        onClick={onBack}
        sx={{ textDecoration: 'underline' }}
      >
        Back to Sign In
      </Link>

    </Box>
  );
};

export default ForgetPassword;

// import React, { useState } from 'react';
// import {
//   Box,
//   Typography,
//   Button,
//   IconButton,
//   TextField,
//   Paper,
//   Link,
//   CircularProgress,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import EmailIcon from '@mui/icons-material/Email';
// import VpnKeyIcon from '@mui/icons-material/VpnKey';
// import { toast } from 'react-toastify';
// import { useDispatch } from 'react-redux';
// import { forgotPassword, resetPassword } from '../../store/slices/authSlice';

// const ForgetPassword = ({ onClose }) => {
//   const dispatch = useDispatch();
//   const [step, setStep] = useState(1); // 1: Email, 2: OTP + Password Reset
//   const [email, setEmail] = useState('');
//   const [otp, setOtp] = useState('');
//   const [password, setPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const [emailError, setEmailError] = useState('');
//   const [otpError, setOtpError] = useState('');
//   const [passwordError, setPasswordError] = useState('');
//   const [confirmPasswordError, setConfirmPasswordError] = useState('');
//   const [isLoading, setIsLoading] = useState(false);

//   // Step 1: Handle email submission
//   const handleEmailSubmit = async () => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!email) {
//       setEmailError('Email is required');
//       return;
//     }
//     if (!emailRegex.test(email)) {
//       setEmailError('Please enter a valid email');
//       return;
//     }

//     setIsLoading(true);
//     try {
//       const payload = { type: 'email', value: email };
//       await dispatch(forgotPassword(payload));
//       toast.success('Password reset email with OTP sent! Check your inbox.');
//       setEmailError('');
//       setStep(2); // Move to OTP + Password step
//     } catch (error) {
//       console.error('Forgot password error:', error);
//       const errors = error.response?.data?.data;
//       if (errors) {
//         if (errors.type) setEmailError(errors.type[0]);
//         if (errors.value) setEmailError(errors.value[0]);
//       } else {
//         toast.error(error.response?.data?.message || 'Failed to send reset email.');
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Step 2: Handle password reset submission
//   const handlePasswordSubmit = async () => {
//     if (!otp) {
//       setOtpError('OTP is required');
//       return;
//     }
//     if (!/^\d{6}$/.test(otp)) {
//       setOtpError('OTP must be a 6-digit code');
//       return;
//     }
//     if (!password) {
//       setPasswordError('Password is required');
//       return;
//     }
//     if (password.length < 8) {
//       setPasswordError('Password must be at least 8 characters long');
//       return;
//     }
//     if (!confirmPassword) {
//       setConfirmPasswordError('Confirm Password is required');
//       return;
//     }
//     if (password !== confirmPassword) {
//       setConfirmPasswordError('Passwords do not match');
//       return;
//     }

//     setIsLoading(true);
//     try {
//       const payload = { type: 'email', value: email, otp, password, password_confirmation: confirmPassword };
//       await dispatch(resetPassword(payload));
//       toast.success('Password reset successfully! You can now sign in.');
//       setOtpError('');
//       setPasswordError('');
//       setConfirmPasswordError('');
//       onClose(); // Close modal or redirect to login
//     } catch (error) {
//       console.error('Password reset error:', error);
//       const errors = error.response?.data?.data;
//       if (errors) {
//         if (errors.otp) setOtpError(errors.otp[0]);
//         if (errors.password) setPasswordError(errors.password[0]);
//         if (errors.password_confirmation) setConfirmPasswordError(errors.password_confirmation[0]);
//         if (errors.value) setEmailError(errors.value[0]);
//       } else {
//         toast.error(error.response?.data?.message || 'Failed to reset password.');
//       }
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Handle form submission based on current step
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (step === 1) handleEmailSubmit();
//     else if (step === 2) handlePasswordSubmit();
//   };

  // return (
  //   <Box
  //     sx={{
  //       position: 'fixed',
  //       top: 0,
  //       left: 0,
  //       width: '100%',
  //       height: '100%',
  //       backgroundColor: 'rgba(0, 0, 0, 0.4)',
  //       display: 'flex',
  //       justifyContent: 'center',
  //       alignItems: 'center',
  //       zIndex: 1300,
  //     }}
  //     onClick={(event) => {
  //       if (event.target === event.currentTarget) {
  //         onClose();
  //       }
  //     }}
  //   >
  //     <Paper
  //       elevation={3}
  //       sx={{
  //         width: '100%',
  //         maxWidth: 400,
  //         padding: 4,
  //         borderRadius: '8px',
  //         textAlign: 'center',
  //       }}
  //     >
  //       <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: -2 }}>
  //         <IconButton onClick={onClose} size="small" aria-label="close">
  //           <CloseIcon />
  //         </IconButton>
  //       </Box>

  //       <Typography
  //         variant="h5"
  //         component="h1"
  //         sx={{ fontWeight: 'bold', mb: 3, color: '#333' }}
  //       >
  //         {step === 1 ? 'Forgot Password' : 'Reset Password'}
  //       </Typography>

  //       <Typography
  //         variant="body2"
  //         color="textSecondary"
  //         sx={{ mb: 3 }}
  //       >
  //         {step === 1
  //           ? 'Enter your email address to receive an OTP for resetting your password.'
  //           : 'Enter the OTP, new password, and confirm password to reset your account.'}
  //       </Typography>

  //       <form onSubmit={handleSubmit}>
  //         {step === 1 && (
  //           <TextField
  //             fullWidth
  //             variant="outlined"
  //             placeholder="Email address"
  //             value={email}
  //             onChange={(e) => {
  //               setEmail(e.target.value);
  //               setEmailError('');
  //             }}
  //             error={!!emailError}
  //             helperText={emailError}
  //             disabled={isLoading}
  //             InputProps={{
  //               startAdornment: (
  //                 <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
  //                   <EmailIcon color="action" />
  //                 </Box>
  //               ),
  //               sx: { borderRadius: '4px', backgroundColor: '#f8f9fa' },
  //             }}
  //             sx={{ mb: emailError ? 1 : 3 }}
  //           />
  //         )}

  //         {step === 2 && (
  //           <>
  //             <TextField
  //               fullWidth
  //               variant="outlined"
  //               placeholder="Email address"
  //               value={email}
  //               onChange={(e) => {
  //                 setEmail(e.target.value);
  //                 setEmailError('');
  //               }}
  //               error={!!emailError}
  //               helperText={emailError}
  //               disabled={isLoading}
  //               InputProps={{
  //                 startAdornment: (
  //                   <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
  //                     <EmailIcon color="action" />
  //                   </Box>
  //                 ),
  //                 sx: { borderRadius: '4px', backgroundColor: '#f8f9fa' },
  //               }}
  //               sx={{ mb: emailError ? 1 : 2 }}
  //             />
  //             <TextField
  //               fullWidth
  //               variant="outlined"
  //               placeholder="6-digit OTP"
  //               value={otp}
  //               onChange={(e) => {
  //                 setOtp(e.target.value);
  //                 setOtpError('');
  //               }}
  //               error={!!otpError}
  //               helperText={otpError}
  //               disabled={isLoading}
  //               inputProps={{ maxLength: 6 }}
  //               InputProps={{
  //                 startAdornment: (
  //                   <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
  //                     <VpnKeyIcon color="action" />
  //                   </Box>
  //                 ),
  //                 sx: { borderRadius: '4px', backgroundColor: '#f8f9fa' },
  //               }}
  //               sx={{ mb: otpError ? 1 : 2 }}
  //             />
  //             <TextField
  //               fullWidth
  //               variant="outlined"
  //               placeholder="New Password"
  //               type="password"
  //               value={password}
  //               onChange={(e) => {
  //                 setPassword(e.target.value);
  //                 setPasswordError('');
  //               }}
  //               error={!!passwordError}
  //               helperText={passwordError}
  //               disabled={isLoading}
  //               InputProps={{
  //                 startAdornment: (
  //                   <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
  //                     <VpnKeyIcon color="action" />
  //                   </Box>
  //                 ),
  //                 sx: { borderRadius: '4px', backgroundColor: '#f8f9fa' },
  //               }}
  //               sx={{ mb: passwordError ? 1 : 2 }}
  //             />
  //             <TextField
  //               fullWidth
  //               variant="outlined"
  //               placeholder="Confirm Password"
  //               type="password"
  //               value={confirmPassword}
  //               onChange={(e) => {
  //                 setConfirmPassword(e.target.value);
  //                 setConfirmPasswordError('');
  //               }}
  //               error={!!confirmPasswordError}
  //               helperText={confirmPasswordError}
  //               disabled={isLoading}
  //               InputProps={{
  //                 startAdornment: (
  //                   <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>
  //                     <VpnKeyIcon color="action" />
  //                   </Box>
  //                 ),
  //                 sx: { borderRadius: '4px', backgroundColor: '#f8f9fa' },
  //               }}
  //               sx={{ mb: confirmPasswordError ? 1 : 3 }}
  //             />
  //           </>
  //         )}

  //         <Button
  //           fullWidth
  //           variant="contained"
  //           size="large"
  //           type="submit"
  //           disabled={isLoading}
  //           sx={{
  //             backgroundColor: '#1976d2',
  //             '&:hover': { backgroundColor: '#1565c0' },
  //             textTransform: 'uppercase',
  //             fontWeight: 'bold',
  //             py: 1.5,
  //             mb: 2,
  //           }}
  //         >
  //           {isLoading ? (
  //             <CircularProgress size={24} color="inherit" />
  //           ) : step === 1 ? (
  //             'Send OTP'
  //           ) : (
  //             'Reset Password'
  //           )}
  //         </Button>

  //         <Link
  //           component="button"
  //           variant="body2"
  //           onClick={onClose}
  //           sx={{
  //             cursor: 'pointer',
  //             textDecoration: 'none',
  //             color: '#1976d2',
  //             '&:hover': { textDecoration: 'underline' },
  //           }}
  //         >
  //           Back to Sign In
  //         </Link>
  //       </form>
  //     </Paper>
  //   </Box>
  // );
// };

// export default ForgetPassword;